export default __webpack_public_path__ + "static/images/appstore-badge-c496afbe4c93ad94da22052ce7ab625e.jpg";